<template>
  <div>
    <health-widget icon="Dynamics"
                   title="Динамика"
                   subtitle="Здесь вы можете посмотреть показания за все сеансы"
                   class="health-widget"/>

    <collapse-card open :loading="loading">
      <div slot="title">Изменения показателей</div>
      <indicators></indicators>
    </collapse-card>

    <collapse-card open :loading="loading">
      <div slot="title">Таблица диагностики</div>
      <tables></tables>
    </collapse-card>

    <collapse-card open :loading="loading">
      <div slot="title">Устройства</div>

      <div slot="link">
        <el-select
            v-model="devicesType"
            size="small"
            class="collapse-select"
            placeholder="Выберите департамент..."
        >
          <el-option
              v-for="item in devicesTypes"
              :key="item.id"
              :label="item.title"
              :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <devices :device="devicesType"/>

    </collapse-card>


  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import HealthWidget from "@/components/elements/HealthWidget.vue"
import CollapseCard from "@/components/elements/BigCard.vue"

import Indicators from "@/components/dynamics/Indicators.vue"
import Tables from "@/components/dynamics/Tables.vue"
import Devices from "@/components/dynamics/Devices.vue"

export default {
  name: "visit.dynamics",
  data() {
    return {
      loading: false,
      devicesType: null,
      devicesTypes: []
    }
  },
  components: {
    HealthWidget,
    CollapseCard,
    Indicators,
    Tables,
    Devices,
  },
  computed: {
    ...mapGetters("visit", {recommendation: "recommendation"}),
    ...mapGetters("visit", {comment: "comment"}),

    visit() {
      return this.$route.params.visit;
    },
  },
  created() {
    if (this.visit) this.loadLogic();
    else this.$router.push({name: "visit.list"});
  },
  filters: {},
  mounted() {
    this.setStageVisit(2)
  },
  methods: {
    ...mapActions({
      setStageVisit: "visit/SET_STAGE",
      setVisit: "visit/SET_DATA",
    }),
    loadLogic() {
      this.loading = true
      this.$api.mobileDevice.getList()
          .then((response) => {
            this.devicesTypes = response.data
            this.devicesType = response.data[0].id
          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка загрузки списка 😕",
              message: response.response.data.message,
            });
          })
          .finally(() => {
            this.loading = false
          })
    },


  },
}
</script>

<style scoped lang="scss">

.collapse-select {
  width: 245px;

  /deep/ .el-input__inner {
    padding: 15px 12px !important;
  }
}
</style>
